if (window.location.host) {
  $(".option-text__mobile-site-url").text(`${window.location.host}/mobile6`);
}

$(".mobile-site-url").on("click", () => {
  window.location.href = "/mobile6";
});
